module.exports = __webpack_public_path__ + "static/media/480.dac8b38a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-rock/light/480.png
// module id = 2378
// module chunks = 2